<template>
  <div class="notes">
    <panel>
      <h1>{{header}}</h1>
      <list :items="formattedNotes" :loading="fetching" @edit="onEdit" @delete="onDelete" @reached-bottom="onReachedBottom">
        <template v-slot:itemDisplay="{ item }">
          <span class="weekday">
            [{{getDayFromTimestamp(item.date)}}]
          </span> 
          <span>{{item.value}}</span>
        </template>
      </list>
      <br>
      <div class="input">
        <input type="text" v-model="text" :disabled="loadingIds.length !== 0" autofocus @input="onInput">
        <div class="options">
          <input v-model="date" type="date" name="date" id="">
          <button @click="create">Create</button>
        </div>
      </div>
    </panel>
  </div>
</template>

<script>

import { getDayFromTimestamp } from '../assets/js/helpers'

export default {
    name: 'Date',
    data() {
      return {
        header: 'Date',
        labelId: 6,
        localStorageKey: 'new_date_text',
        notes: [],
        text: localStorage.getItem('new_date_text') || '',
        loadingIds: [],
        skip: 0,
        limit: 15,
        increase: 15,
        fetching: false,
        fetchedEverything: false,
        date: undefined
      }
    },
    methods: {
      getDayFromTimestamp(timestamp) {
        return getDayFromTimestamp(timestamp)
      },
      onReachedBottom() {
        if (this.fetchedEverything) return;
        if (this.fetching) return;

        this.skip += this.increase; 
        this.get();
      },
      get() {
        this.fetching = true;

        this.axios.get(this.config.api + `/notes?limit=${this.limit}&offset=${this.skip}&labelId=${this.labelId}`)
          .then(result => {
            this.fetching = false;

            this.fetchedEverything = result.data.length < this.increase;

            this.notes = [...this.notes, ...result.data];
          })
          .catch(error => {
            const isAuthenticationError = error.message.includes('401');

            if (isAuthenticationError)
              return this.$router.push('/authorization')
            else alert(error.message)
          })
      },
      create() {
        if (!this.text || !this.date) return;
        
        const timestamp = new Date(this.date).getTime();

        this.axios.post(this.config.api + '/notes', { text: this.text, labelId: this.labelId, date: timestamp })
          .then(result => {
            localStorage.removeItem(this.localStorageKey);
            this.text = '';
            this.date = undefined;

            this.notes.push({
              id: result.data.id,
              text: result.data.text,
              date: timestamp
            })
          })
          .catch(error => {
            alert(error.message);
          })
      },
      update(id, text) {
        this.loadingIds.push(id);
        const noteIndex = this.notes.map(note => note.id).indexOf(id);
        this.notes[noteIndex].text = text;

        this.axios.put(this.config.api + '/notes/' + id, { text })
          .then(() => {
            const loadingIdIndex = this.loadingIds.indexOf(id);

            this.loadingIds.splice(loadingIdIndex, 1);
          })
          .catch(error => {
            alert(error.message);
          })
      },
      onInput() {
        localStorage.setItem(this.localStorageKey, this.text);
      },
      onEdit(item) {
        if (item.value === '') return;

        this.update(item.id, item.value);
      },
      onDelete(item) {
        
        if (confirm('are you sure?')) {
          this.loadingIds.push(item.id);
          
          this.axios.delete(this.config.api + '/notes/' + item.id)
            .then(() => {
              const index = this.notes.findIndex(item_ => item_.id === item.id);

              this.notes.splice(index, 1);
            })
            .catch(error => {
              alert(error.message);
            })
        }
      }
    },
    computed: {
      formattedNotes: function() {
        return this.notes.map(note => {
          return {
            id: note.id,
            value: note.text,
            loading: this.loadingIds.includes(note.id),
            date: note.date
          }
        });
      }
    },
    created() {
      this.get();
    }
}
</script>

<style scoped>

.notes {
  height: 100%;
}

input[type=date] {
  width: 100px;
}

.options {
  display: flex;
  justify-content: space-between;
  padding: 5px 0 0 0;
}


span.weekday {
  color: #29415c
}

</style>


// WEBPACK FOOTER //
// src/components/Date.vue